<template>
  <div class="wrapper">
    <open-app @openLinkApp="openLinkApp" :small-btn="true" v-show="!isHarmony && !isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient" />
    <w-nav-bar :nav_title="navTitle" icon="" :style="{top: (isHarmony || isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '0px' : '56px'}" class="navbar" v-show="iosOrAndroidShow"/>
    <div v-if="notData" class="not-data">
      <img src="https://files.wondercv.com/404_moblie.png" alt="">
    </div>
    <div v-else class="content" :style="{paddingTop: (isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '60px' : '116px'}">

      <div class="user-info">
        <div class="avatar-box">
          <img :src="data.user_avatar || defaultAvatar" alt="" class="avatar">
        </div>
        <div class="info-box">
          <h5 class="name" v-if="data.user_name">{{ data.user_name }}</h5>
          <h6 class="position" v-if="data.user_identity">{{ data.user_identity }}</h6>
        </div>
      </div>

      <p class="description" v-if="data.desc">{{ data.desc }}</p>

      <div class="email handler" v-if="data.email">
        <div class="input-title">
          <h5 class="left-title">邮箱</h5>
          <div class="right-button" @click="handlerCopy('email')">复制邮箱</div>
        </div>
        <input ref="email" class="input" type="text" :value="data.email" readonly>
      </div>

      <div class="link handler" v-if="data.url">
        <div class="input-title">
          <h5 class="left-title">内推链接</h5>
          <div class="right-button" @click="handlerCopy('link')">复制链接</div>
        </div>
        <input ref="link" class="input" type="text" :value="data.url" readonly>
      </div>

      <div class="code handler" v-if="data.code">
        <div class="input-title">
          <h5 class="left-title">内推码</h5>
          <div class="right-button" @click="handlerCopy('code')">复制内推码</div>
        </div>
        <input ref="code" class="input" type="text" :value="data.code" readonly>
      </div>

      <div class="img-box" v-if="data.img">
        <img class="img" :src="data.img" alt="">
      </div>

    </div>
  </div>
</template>

<script>
  import WNavBar from '@/components/global/w-navbar'
  import OpenApp from '../../components/cv/open-app'
  import { envMixin, eventMixin, downloadAPPMixin } from '../../assets/js/mixin/global'
  import { componentsMixin } from '../../assets/js/mixin/components'

  export default {
    mixins: [ eventMixin, envMixin, componentsMixin, downloadAPPMixin ],
    data () {
      return {
        data: {},
        navTitle: '内推详情',
        token: null, // 内推token
        mapData: {    //映射表
          link: '链接',
          code: '内推码',
          email: '邮箱'
        },
        defaultAvatar: 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round1.png', // 默认头像
        notData: true // 接口是否请求到数据
      }
    },
    components: {
      WNavBar,
      OpenApp
    },
    created () {
      this.init()
    },
    methods: {
      // 打开APP
      openLinkApp(needReload) {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&token=${this.$route.params.token}&open_type=recommendation`,
          android: `android://h5/open?token=${this.$route.params.token}&type=recommendation`,
        }
        this.openApp(link, needReload)
      },
      // 初始化
      init () {
        this.token = this.$route.params.token
        this.getRecommendationDetail()
      },
      // 获取内推详情
      async getRecommendationDetail () {
        if (!this.token) return false
        try {
          let res = await this.$api.jobs.getRecommendationDetail(this.token)
          if (res.code === 1000) {
            this.data = res.data
            this.notData = false
          } else {
            this.showToast('error：内推详情获取失败')
          }
        } catch (e) {
          console.log(e)
        }
      },
      // 复制
      handlerCopy (input) {
        this.$refs[input].select() // 选择对象
        document.execCommand("Copy") // 执行浏览器复制命令
        this.showToast(`${this.mapData[input]}已复制`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding: 110px 24px 24px;

    .user-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .avatar-box {
        width: 42px;
        height: 42px;
        margin-right: 10px;

        .avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .info-box {
        flex: 1;

        .name {
          font-size: 16px;
          font-weight: 500;
          color: #404040;
          line-height: 22px;
        }

        .position {
          font-size: 12px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 17px;
        }
      }
    }

    .description {
      font-size: 16px;
      font-weight: 400;
      color: #404040;
      line-height: 24px;
      margin-top: 15px;
    }

    .handler {
      margin-top: 24px;

      .input-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .left-title {
          font-size: 16px;
          font-weight: 500;
          color: #404040;
          line-height: 22px;
        }

        .right-button {
          padding: 4px 12px;
          font-size: 14px;
          font-weight: 400;
          color: #FF6644;
          line-height: 20px;
          background: #FFFFFF;
          border-radius: 15px;
          border: 1px solid #FF8569;
        }
      }

      .input {
        width: 100%;
        height: 40px;
        border-color: #ECECEC;
        border-radius: 4px;
      }

      &.link .input,
      &.email .input {
        font-size: 14px;
        font-weight: 400;
        color: #606060;
      }

      &.code .input {
        font-size: 20px;
        font-weight: 500;
        color: #404040;
        letter-spacing: 2px;
      }
    }

    .img-box {
      width: 100%;
      height: auto;
      margin-top: 24px;

      .img {
        width: 100%;
      }
    }
  }
  .not-data {
    height: 100vh;
    background-color: #fff;
    overflow: hidden;
    img {
      width: 100vw;
    }
  }
</style>
